module.exports = __webpack_public_path__ + "static/img/logo.974ea5cf.png";